// extracted by mini-css-extract-plugin
module.exports = {"containerform":"todoList_containerform__3UEdx","todoContainer":"todoList_todoContainer__1hR5Q","btn":"todoList_btn__4_T7i"};